import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgWallet = ({ title, titleId, desc, descId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#Wallet_svg__a)">
      <path
        fill="currentColor"
        d="M13.64 16.001H2.36A2.363 2.363 0 0 1 0 13.641V2.361A2.364 2.364 0 0 1 2.361 0h9.667a.75.75 0 1 1 0 1.5H2.361a.861.861 0 0 0 0 1.722H13.64A2.364 2.364 0 0 1 16 5.584v8.056a2.364 2.364 0 0 1-2.36 2.361M1.5 4.561v9.08a.86.86 0 0 0 .861.86H13.64a.86.86 0 0 0 .861-.86V5.583a.863.863 0 0 0-.86-.862H2.36c-.295 0-.587-.054-.861-.162m10.125 6.2a1.152 1.152 0 1 1 0-2.305 1.152 1.152 0 0 1 0 2.305"
      />
    </g>
    <defs>
      <clipPath id="Wallet_svg__a">
        <path fill="#fff" d="M0 0h16v16.001H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWallet;
